
import overview from "./overview/routing";
import settings from "./settings/routing";
import deliverables from "./deliverables/routing";
import model from "./model/routing";
import conv from "./conversations/routing";

export default {
    path: 'project/:pid',
    component: () => import("./ProjectPage"),
    name: 'project',
    props: (route) => ({
        route: route,
        pid: route.params.pid,
    }),
    children: [
        overview,
        settings,
        deliverables,
        model,
        conv,
    ]
};
